module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Philip John Paul Gonzales, Cyril O'Regan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("Philip John Paul Gonzales")]), _vm._v(" is an assistant professor of philosophy at the University of Dallas. He is the editor of "), _c('I', [_vm._v("Exorcising Philosophical Modernity: Cyril O'Regan and Christian Discourse after Modernity")]), _vm._v(" and the author of numerous articles, book chapters, and reviews.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KpfJjQ/tc-custom/9781467452557.jpg?1728851777336",
      "alt": "This image is the cover for the book Reimagining the Analogia Entis, Interventions (INT)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Reimagining the Analogia Entis, Interventions (INT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In 1932 German theologian and philosopher Erich Przywara penned his "), _c('i', [_vm._v("Analogia Entis")]), _vm._v(", a vision of the analogy of being and a metaphysical exploration of the dynamic between God and creation. A translation into English in 2014 made Przywara’s brilliant and influential work available to more people than ever before. ")]), _c('p', [_vm._v("In this book Philip Gonzales calls English-speaking readers to embrace the Christian treasure of the "), _c('i', [_vm._v("Analogia Entis ")]), _vm._v("and to reimagine what it offers Christians today. Gonzales brings Przywara’s text into dialogue with debates in contemporary philosophy and theology, engaging in conversation with Edith Stein, Karl Barth, Martin Heidegger, the "), _c('i', [_vm._v("Nouvelle théologie")]), _vm._v(", Vatican II, and leading figures in postmodern theology and the Continental turn to religion. The first book of its kind in English, "), _c('i', [_vm._v("Reimagining the “Analogia Entis” ")]), _vm._v("articulates a Christian vision of being for the postmodern era.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0